import React from 'react';

const Help = () => {
  return (
    <div className="max-w-3xl mx-auto space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Help &amp; Support</h1>
        <p className="text-sm text-slate-500 mt-0.5">
          Need assistance with your events or photos? We&apos;re here to help.
        </p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
        <h2 className="text-sm font-semibold text-slate-800 mb-2">Contact us</h2>
        <p className="text-sm text-slate-600">
          For any questions, issues, or feedback about Pixel App, please email us at:
        </p>
        <p className="mt-3">
          <a
            href="mailto:info@aismartevents.com"
            className="inline-flex items-center gap-2 text-sm font-semibold text-violet-700 hover:text-violet-900 hover:underline"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            info@aismartevents.com
          </a>
        </p>
        <p className="mt-2 text-xs text-slate-400">
          We usually respond within 1–2 business days.
        </p>
      </div>
    </div>
  );
};

export default Help;

